import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Book, Star, Sparkles, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CarteDeCart = () => {
  const features = [
    "Capital-band din șuviță de piele",
    "Două semne de carte",
    "Canturile blocului de carte sunt aurite",
    "Nervuri pe cotor (binduri)",
    "Piciorușe metalice ornamentale",
    "Ambalaje de lux pentru cărți unicat",
    "Ambalaj textil neţesut pentru cărți standard",
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-grow pt-20">
        {/* Hero Section */}
        <section className="relative py-32 pb-24 overflow-hidden bg-gradient-to-br from-burgundy-dark/10 via-gold/5 to-background">
          <div className="absolute inset-0">
            <div className="absolute top-20 left-10 w-[500px] h-[500px] bg-gold/10 rounded-full blur-3xl animate-float"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-burgundy/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-5xl mx-auto text-center">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gold/10 backdrop-blur-sm border border-gold/20 rounded-full mb-8 animate-fade-in">
                <Book className="w-5 h-5 text-gold" />
                <span className="text-gold font-semibold text-sm font-lora">Legătorie de artă</span>
              </div>

              <h1 className="text-6xl md:text-8xl font-bold text-primary mb-8 animate-fade-in font-playfair leading-tight" style={{ animationDelay: '0.2s' }}>
                Carte de cult ortodoxă
              </h1>

              <p className="text-xl md:text-3xl text-muted-foreground mb-8 animate-fade-in font-lora leading-relaxed max-w-4xl mx-auto" style={{ animationDelay: '0.4s' }}>
                Să creezi „veșmântul de aur" pentru cărțile de slujire și de rugăciune este darul din har 
                pe care echipa atelierelor Idaco l-a primit pentru a vă oferi modele unicat și serii mici 
                ale copertelor ce poartă „cuvinte" sfinte.
              </p>

              <Link to="/magazin">
                <Button size="lg" className="animate-fade-in hover-scale hover-glow shadow-2xl text-lg px-10 py-7 rounded-full bg-primary hover:bg-primary/90" style={{ animationDelay: '0.6s' }}>
                  <Star className="w-5 h-5 mr-2" />
                  Vezi colecția
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Description Section */}
        <section className="py-24 bg-gradient-to-b from-background to-cream/20">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <div className="bg-card/90 backdrop-blur-sm rounded-[2rem] p-10 md:p-16 border-2 border-border/50 shadow-2xl animate-fade-in relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl"></div>
                
                <div className="flex items-start gap-6 mb-10 relative">
                  <div className="w-16 h-16 bg-gold/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <Sparkles className="w-8 h-8 text-gold" />
                  </div>
                  <div>
                    <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-playfair">
                      Inspirație și măiestrie
                    </h2>
                    <p className="text-lg md:text-xl text-muted-foreground mb-6 leading-relaxed font-lora">
                      Ne-am inspirat din ornamentele cărților bisericești vechi sau din frizele decorative 
                      ale lăcașurilor de cult ortodoxe. Pentru efecte deosebite, am aplicat pietre semiprețioase, 
                      emailuri, miniaturi sculptate în lemn, încercând să punem în armonie materialele, 
                      modelele, cu destinația cărții.
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-gold/10 to-burgundy/10 rounded-2xl p-8 border-2 border-gold/20 relative">
                  <h3 className="text-2xl md:text-3xl font-bold text-primary mb-6 font-playfair">
                    Observații importante
                  </h3>
                  <ul className="space-y-5 text-muted-foreground font-lora text-lg">
                    <li className="flex items-start gap-4">
                      <Heart className="w-6 h-6 text-gold flex-shrink-0 mt-1" />
                      <span>La cerere, toate detaliile prezentate pot fi adaptate în funcție de dorințele solicitanților</span>
                    </li>
                    <li className="flex items-start gap-4">
                      <Heart className="w-6 h-6 text-gold flex-shrink-0 mt-1" />
                      <span>Putem recoperta și recondiționa cărțile de slujire care au fost întrebuințate, folosind materiale de bună calitate</span>
                    </li>
                    <li className="flex items-start gap-4">
                      <Heart className="w-6 h-6 text-gold flex-shrink-0 mt-1" />
                      <span>La solicitare putem recoperta orice carte, în acord cu cerințele clientului (cărți cu valoare sentimentală, albume, cărți dragi)</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-24 bg-gradient-to-b from-cream/30 to-background relative overflow-hidden">
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-burgundy/5 rounded-full blur-3xl animate-float"></div>
          
          <div className="container mx-auto px-4 relative">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-5xl md:text-6xl font-bold text-primary mb-6 font-playfair">
                  Detalii comune pentru cărțile de slujire
                </h2>
                <p className="text-xl text-muted-foreground font-lora max-w-3xl mx-auto">
                  Fiecare carte este realizată cu atenție deosebită la detalii și măiestrie artizanală
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-5 p-8 bg-card/90 backdrop-blur-sm rounded-2xl border-2 border-border/50 hover:border-gold/30 transition-all duration-500 hover-scale hover:shadow-2xl animate-fade-in group"
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    <div className="w-12 h-12 bg-gold/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-gold/20 transition-colors">
                      <Star className="w-6 h-6 text-gold group-hover:scale-110 transition-transform" />
                    </div>
                    <p className="text-foreground font-lora pt-2.5 text-lg leading-relaxed">{feature}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-gradient-to-br from-burgundy/10 via-gold/5 to-background relative overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute top-20 left-10 w-96 h-96 bg-burgundy/10 rounded-full blur-3xl animate-float"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-gold/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
          </div>

          <div className="container mx-auto px-4 relative text-center">
            <h2 className="text-5xl md:text-6xl font-bold text-primary mb-8 font-playfair animate-fade-in">
              Comandă o carte unicat
            </h2>

            <p className="text-xl md:text-2xl text-muted-foreground max-w-4xl mx-auto mb-10 font-lora animate-fade-in leading-relaxed" style={{ animationDelay: '0.2s' }}>
              Fie că doriți o carte de slujire personalizată sau să restaurați o carte prețioasă, 
              suntem aici să transformăm visul în realitate.
            </p>

            <Link to="/#contact">
              <Button size="lg" className="animate-fade-in hover-scale hover-glow shadow-2xl text-lg px-10 py-7 rounded-full bg-primary hover:bg-primary/90" style={{ animationDelay: '0.4s' }}>
                <Heart className="w-5 h-5 mr-2" />
                Contactează-ne
              </Button>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CarteDeCart;
